import { useEffect, useState } from "react"
import { WINDOW_WIDTH } from "src/libs/interfaces/layouts"
import useScreenSize from "src/modules/pe-basic-module/hooks/useScreenSize"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { CARD_NOSE_SHIFT_Y, ITimelineCard, NOSE_WIDTH } from "src/modules/pe-landing-module/data/interfaces"
import { ICardsProps } from "../../Cards"
import { TimelineDot } from "./TimelineDot"


/* Protopia Ecosystem component */ 
const AMPLITUDE = 116,
    PHASE = Math.PI / 2, 
    LENGTH = .27

const TimeLineDiagramGallery = ({...props}: ICardsProps): JSX.Element => {
    const sizes             = useScreenSize()
    const data              = props.data 
    const getAmplitude = (): number => {
        return sizes.width >= WINDOW_WIDTH.TABLET
            ?
            !!data.dots && typeof data.dots?.amplitude !== "undefined" 
                ? 
                data.dots.amplitude 
                : 
                AMPLITUDE 
            :
            0
    }
    const is_two_side       = sizes.width >= WINDOW_WIDTH.TABLET && data.is_two_side 
    const cards: ITimelineCard[] = data.cards as ITimelineCard[]
    const perimeter         = data.dots.perimeter
    const amplitude                 = useSyncState<number>( getAmplitude() )
    const shift                     = useSyncState<number>( getAmplitude() + 5 )
    const [strokeWidth, ]           = useState<number>( data.dots?.stroke_width || 100 )
    const [length, setLength]       = useState<number>( data.dots?.length || LENGTH )
    const [phase, setOhase]         = useState<number>( !!data.dots && typeof data.dots.phase !== "undefined" ? data.dots.phase : PHASE )
    const pathLength                = useSyncState<number>( 0 )
    const path                      = useSyncState<string>( "" ) 
    
    const h = pathLength.get() + (data.gap || 0) * cards.length
    const w = shift.get() * 2 + strokeWidth * 1.5

    const getX = (y:number, i:number) : number => {
        return shift.get() + i % 2 * ( strokeWidth + perimeter )  + 
            amplitude.get() * Math.cos( y * Math.PI / 180 * length + phase)  
    }
    
    const step = ( i:number ) => {
        return shift.get() - 100 + amplitude.get() * Math.cos( i * Math.PI / 180 * length + phase )
    }
    const sinusoid = ( ) => {
        let _path = ""
        for(var i:number = 0; i < pathLength.get() + perimeter; i++) { 
            const x =  step(i) + strokeWidth * .5
            _path += i === 0 
                ?
                `M${x} ${i}`
                :
                `L${x} ${i}`
        }
        _path += `L${step(i) + strokeWidth * 1.5 + perimeter}  ${i}`
        for( var i:number = pathLength.get() + perimeter - 1; i > 0; i-- ) { 
            const x =  step(i) + strokeWidth * 1.5 + perimeter
            _path += i === 0 
                ?
                `M${x} ${i}`
                :
                `L${x} ${i}`
        }
        path.set( _path )
    }

    useEffect(() => {
        amplitude.set(
            sizes.width >= WINDOW_WIDTH.TABLET ? getAmplitude() : 0
        )         
        shift.set(
            sizes.width >= WINDOW_WIDTH.TABLET ? getAmplitude() + 5 : 5
        )         
        const timeout = setTimeout(() => {
            const selector = `.landing-card-${cards[0]?.id}`
            pathLength.set(
                ( document.querySelector( selector )?.clientHeight || 0 ) * 
                ( is_two_side 
                    ? 
                    cards.length / 2 - ( ( cards.length / 2 ) % 2 ) / 2 
                    : 
                    cards.length - 1 
                ) +
                perimeter/2
            )
            sinusoid()
            // odd down shift
            if( is_two_side ) {
                const selector = `.landing-v-timeline-cards-${props.section.id} .timeline-shifter`
                const query = document.querySelector(selector)!
                const card0 = document.querySelector(`.landing-card-${cards[0]?.id}`)
                if(query) {
                    query?.setAttribute("style",`height:${ !!card0 ? card0.clientHeight / 2 : "0"}px`)
                } 
            }
        }, 100)
        return () => { 
            clearTimeout(timeout)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[ data.dots, sizes.width, is_two_side ])

    return <div 
        className={`landing-v-timeline-timiline-container position-relative`} 
        style={{
            marginTop: CARD_NOSE_SHIFT_Y - perimeter + (data.gap || 0) / 2 + NOSE_WIDTH,
            width: w, maxWidth: w,
            marginLeft:  sizes.width >= WINDOW_WIDTH.TABLET ? perimeter / 2 + NOSE_WIDTH + 30 : 0,
            marginRight: sizes.width >= WINDOW_WIDTH.TABLET ? perimeter / 2 + NOSE_WIDTH + 30 : 30
        }} 
    > 
        <svg 
            version="1.1" 
            xmlns="http://www.w3.org/2000/svg" 
            xmlnsXlink="http://www.w3.org/1999/xlink" 
            x="0px" 
            y="0px"
            width={ w }
            height={ h }
            viewBox={`0 0 ${ w } ${ h }`}
            xmlSpace="preserve"
            className="" 
        >
            <defs>
                <pattern id={`img-${props.section.id}`} patternUnits="userSpaceOnUse" width={w} height={h} >
                    <image href={data.dots?.image} x="0" y="0" width={w} height={h} />
                </pattern>
            </defs>
            <path 
                fill={`url(#img-${props.section.id})`}
                strokeWidth={ 0 }
                stroke="none"
                strokeMiterlimit="10"  
                style={data.dots?.svg_style} 
                d={path.get()}
            />
        </svg>
        {
            Array.isArray(cards) && cards.map((card: ITimelineCard, i: number) =>  { 
                return <TimelineDot
                    key={ card.id }
                    i={i}
                    section={ props.section } 
                    data={data}
                    is_two_side={is_two_side}
                    card={card}
                    shift={shift.get()}
                    amplitude={amplitude.get()}
                    length={length}
                    phase={phase}
                    getX={getX}
                />
            })
        }
    </div>
}
export default TimeLineDiagramGallery